import { render, staticRenderFns } from "./message.vue?vue&type=template&id=ab945854&"
import script from "./message.vue?vue&type=script&lang=ts&"
export * from "./message.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab945854')) {
      api.createRecord('ab945854', component.options)
    } else {
      api.reload('ab945854', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=ab945854&", function () {
      api.rerender('ab945854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/pm/message.vue"
export default component.exports